import { Component } from '@angular/core';
import { AbstractQuestionDirective } from '../abstract-question.directive';

@Component({
  selector: 'app-empty-question',
  templateUrl: './empty-question.component.html',
  styleUrls: ['./empty-question.component.scss'],
})
export class EmptyQuestionComponent extends AbstractQuestionDirective {}
